import { DELETE_EDUCATION } from '../actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case DELETE_EDUCATION:
      if (action.payload.data.success) {
        return {
          status: action.payload.data.success
        }
      } else {
        return {
          status: action.payload.data.success,
          error: action.payload.data.error
        }
      }
  }

  return state
}
